import { render, staticRenderFns } from "./service_education.vue?vue&type=template&id=2eb83d5c&scoped=true&"
import script from "./service_education.vue?vue&type=script&lang=js&"
export * from "./service_education.vue?vue&type=script&lang=js&"
import style0 from "./service_education.vue?vue&type=style&index=0&id=2eb83d5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb83d5c",
  null
  
)

export default component.exports